import { formatDollar, formatNumber, formatPercentage } from '../../lib/formatters';
import { ColoredMetric } from '../ColoredMetric/ColoredMetric';

export const ProfitText = ({
  price,
  pnl,
  pnlPercentage,
  type,
  priceDecimals,
}: {
  price: bigint | undefined;
  pnl: bigint | undefined;
  pnlPercentage: bigint | undefined;
  type: 'tp' | 'sl';
  priceDecimals: number;
}) => {
  const typeLabel = type === 'tp' ? 'Take Profit' : 'Stop Loss';

  return (
    <div className="text-3xs text-contentSecondary" data-testid="stop-order-profit-text">
      When Oracle Price reaches{' '}
      {formatNumber(price, {
        maximumFractionDigits: priceDecimals,
        minimumFractionDigits: priceDecimals,
      })}
      , it will trigger {typeLabel} Market order to close this position. Estimated P&L will be{' '}
      <ColoredMetric value={pnl} formatFn={formatDollar} />
      {pnlPercentage !== undefined && (
        <>
          {' '}
          <ColoredMetric value={pnlPercentage} formatFn={(val) => `(${formatPercentage(val)})`} />
        </>
      )}
      .
    </div>
  );
};
